/*
 * Yake — marka karıştırma katmanı (Concept teması)
 * ------------------------------------------------------------------
 * Sorun: koleksiyonlar Shopify'ın depolanan sırasında listeleniyor ve aynı markanın
 * ürünleri arka arkaya blok blok geliyor.
 *
 * Çözüm: sırayı backend'den al (günlük seed + markaya duyarlı dağıtım), kartı ise
 * TEMANIN KENDİSİNE çizdir: /products/<handle>?view=yakecard
 * Böylece kart markup'ı hiç taklit edilmez — quick view, bedene göre hızlı ekle,
 * swatch, rozet, sayaç hepsi temanın orijinal çıktısıdır.
 *
 * Tema dosyalarına dokunulmaz; main-collection bölümüne tek script satırı eklenir.
 * Backend cevap vermezse hiçbir şey yapılmaz → sayfa temanın normal haliyle kalır.
 */
(function () {
  'use strict';

  var cfgEl = document.querySelector('script[data-yake-shuffle]');
  if (!cfgEl) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CFG || !CFG.collection || !CFG.proxy) return;

  var container = document.getElementById('ProductGridContainer');
  if (!container) return;

  var PAGE_SIZE = parseInt(CFG.pageSize, 10) || 50;
  var ROOT = String(CFG.rootUrl || '/').replace(/\/$/, '');
  var VIEW = CFG.cardView || 'yakecard';
  var CONCURRENCY = 8;

  /* ---------------- yardımcılar ---------------- */

  function qs() { return new URLSearchParams(location.search); }

  // Shopify'ın handle üretimiyle uyumlu sadeleştirme: "Ölçü" -> "olcu"
  function handleize(s) {
    return String(s)
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/ı/g, 'i').replace(/İ/g, 'i')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  // Seçenek filtresi adları: Shopify "filter.v.option.beden" der, backend "option_Beden" bekler.
  // Eşleştirme backend'in kendi facet listesinden kurulur, oturum boyunca saklanır.
  var optionNames = null;
  function loadOptionNames() {
    if (optionNames) return Promise.resolve(optionNames);
    var key = 'yake:opt:' + CFG.collection;
    try {
      var cached = sessionStorage.getItem(key);
      if (cached) { optionNames = JSON.parse(cached); return Promise.resolve(optionNames); }
    } catch (e) { /* sessionStorage kapalı olabilir */ }

    var p = new URLSearchParams();
    p.set('collection', CFG.collection);
    p.set('page_size', '1');
    return fetch(CFG.proxy + '?' + p.toString(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var map = {};
        var opts = (d && d.facets && d.facets.options) || [];
        opts.forEach(function (o) { if (o && o.name) map[handleize(o.name)] = o.name; });
        optionNames = map;
        try { sessionStorage.setItem(key, JSON.stringify(map)); } catch (e) { /* yoksay */ }
        return map;
      })
      .catch(function () { optionNames = {}; return optionNames; });
  }

  function hasOptionFilter() {
    var found = false;
    qs().forEach(function (v, k) { if (k.indexOf('filter.v.option.') === 0) found = true; });
    return found;
  }

  function backendQuery(page, names) {
    var q = new URLSearchParams();
    q.set('collection', CFG.collection);
    q.set('page', String(page));
    q.set('page_size', String(PAGE_SIZE));
    qs().forEach(function (v, k) {
      if (!v) return;
      if (k === 'filter.p.vendor') q.append('vendor', v);
      else if (k === 'filter.p.product_type') q.append('product_type', v);
      else if (k === 'filter.p.tag') q.append('tag', v);
      else if (k === 'filter.v.price.gte') q.set('price_min', v);
      else if (k === 'filter.v.price.lte') q.set('price_max', v);
      else if (k === 'filter.v.availability') { if (v === '1') q.set('available', '1'); }
      else if (k.indexOf('filter.v.option.') === 0) {
        var h = k.slice('filter.v.option.'.length);
        q.append('option_' + ((names && names[h]) || h), v);
      }
    });
    return q.toString();
  }

  function fetchOrder(page) {
    var names = hasOptionFilter() ? loadOptionNames() : Promise.resolve(null);
    return names
      .then(function (map) {
        return fetch(CFG.proxy + '?' + backendQuery(page, map), { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { if (!r.ok) throw new Error('proxy ' + r.status); return r.json(); })
      .then(function (d) { return (d && d.items) || []; });
  }

  /* ---------------- kart HTML'i (temanın kendi çıktısı) ---------------- */

  // Kartlar tek istekte alınır: /search?view=yakecards&q=<handle handle ...>
  // Şablon arama sonucunu kullanmaz; q sadece handle listesini taşır (bkz. templates/search.yakecards.liquid).
  // Adres çok uzarsa parçalara bölünür.
  // Shopify'ın all_products'ında istek başına 20 ürün sınırı vardır: fazlası
  // sessizce 20. ürünü tekrarlar. Bu yüzden handle listesi 20'lik parçalara bölünür.
  var MAX_HANDLES = 20;
  var MAX_URL = 6000;

  function chunkHandles(handles) {
    var chunks = [];
    var cur = [];
    var len = 0;
    handles.forEach(function (h) {
      var add = encodeURIComponent(h).length + 1;
      if (cur.length >= MAX_HANDLES || (cur.length && len + add > MAX_URL)) {
        chunks.push(cur); cur = []; len = 0;
      }
      cur.push(h);
      len += add;
    });
    if (cur.length) chunks.push(cur);
    return chunks;
  }

  function fetchCards(handles) {
    var chunks = chunkHandles(handles);
    return Promise.all(
      chunks.map(function (part) {
        var url = ROOT + '/search?view=' + VIEW + '&q=' + part.map(encodeURIComponent).join('+');
        return fetch(url, { headers: { Accept: 'text/html' } })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })
    ).then(function (parts) {
      var wrap = document.createElement('div');
      wrap.innerHTML = parts.join('');
      var cards = [].slice.call(wrap.children).filter(function (n) {
        return n.classList && n.classList.contains('card');
      });
      cards.forEach(function (c) { c.setAttribute('data-yake', '1'); });
      return cards;
    });
  }

  /* ---------------- yerleştirme ---------------- */

  // slots: yerini alacak mevcut kart düğümleri (yer tutucu; düzen kaymasın diye durur)
  function place(grid, items, slots) {
    if (!items.length) {
      if (filterActive()) {
        slots.forEach(function (s) { if (s && s.parentNode) s.remove(); });
        endOfResults(grid);
      }
      return;
    }
    slots.forEach(function (s) { s.style.visibility = 'hidden'; });

    return fetchCards(items.map(function (i) { return i.handle; })).then(function (cards) {
      if (!cards.length) {
        slots.forEach(function (s) { s.style.visibility = ''; }); // kart alınamadı → tema kendi sırasında kalsın
        return;
      }
      cards.forEach(function (card, i) {
        var slot = slots[i];
        if (slot && slot.parentNode) slot.replaceWith(card);
        else grid.appendChild(card);
      });
      // artan yer tutucular (backend daha az ürün döndürdüyse) kaldırılır
      for (var k = cards.length; k < slots.length; k++) {
        if (slots[k] && slots[k].parentNode) slots[k].remove();
      }
      if (filterActive() && cards.length < slots.length) endOfResults(grid);
      if (typeof grid.reload === 'function') { try { grid.reload(); } catch (e) { /* yoksay */ } }
    });
  }

  /* ---------------- akış ---------------- */

  var nextPage = Math.max(1, parseInt(qs().get('page') || '1', 10) || 1);
  var busy = false;

  function currentGrid() { return container.querySelector('motion-list, .card-grid'); }

  // Sıralama seçilmişse kullanıcının isteği önceliklidir; karıştırma devreye girmez.
  // 25 Eyl 2026: filtre seçiliyken (yedek filtre dahil) sıralama parametresi olsa da karıştırma devrede kalır;
  // yoksa büyük koleksiyonlarda filtre hiç uygulanmıyordu (Shopify >5.000 üründe filtreyi yok sayar).
  function filterActive() {
    var f = false;
    qs().forEach(function (v, k) { if (v && k.indexOf('filter.') === 0) f = true; });
    return f;
  }
  function sortingActive() { return !!qs().get('sort_by') && !filterActive(); }

  // Filtreli sonuç bittiğinde temanın filtresiz kartları arkadan görünmesin, sonsuz kaydırma dursun
  function endOfResults(grid) {
    document.querySelectorAll('#ProductGridContainer .infinite-scroll, .collection .infinite-scroll').forEach(function (b) { b.style.display = 'none'; });
    if (grid && !grid.querySelector('.card')) {
      if (!document.getElementById('ykyf-bos')) {
        var dil = (document.documentElement.lang || 'tr').slice(0, 2);
        var m = document.createElement('p'); m.id = 'ykyf-bos';
        m.style.cssText = 'grid-column:1/-1;padding:40px 0;text-align:center;opacity:.7';
        m.textContent = dil === 'ro' ? 'Nu există produse pentru filtrele selectate.' : (dil === 'en' ? 'No products match the selected filters.' : 'Seçili filtrelere uygun ürün bulunamadı.');
        grid.appendChild(m);
      }
    }
  }

  function run(page, slots) {
    var grid = currentGrid();
    if (!grid || sortingActive()) return;
    busy = true;
    fetchOrder(page)
      .then(function (items) { place(grid, items, slots); })
      .catch(function () { slots.forEach(function (s) { s.style.visibility = ''; }); })
      .then(function () { busy = false; });
  }

  function initial() {
    var grid = currentGrid();
    if (!grid) return;
    var slots = [].slice.call(grid.querySelectorAll('.card'));
    if (!slots.length) return;
    run(nextPage, slots);
    nextPage++;
  }

  // Sonsuz kaydırma / filtre değişimi: tema yeni kartlar eklediğinde onları da sıraya sokar.
  function watch() {
    var obs = new MutationObserver(function (muts) {
      var added = [];
      muts.forEach(function (m) {
        [].slice.call(m.addedNodes).forEach(function (n) {
          if (n.nodeType === 1 && n.classList && n.classList.contains('card') && !n.hasAttribute('data-yake')) added.push(n);
        });
      });
      if (!added.length || busy) return;

      var grid = currentGrid();
      if (!grid) return;
      var total = grid.querySelectorAll('.card').length;

      // Griddeki kartların TAMAMI yeniyse: filtre/sıralama değişti, baştan başla.
      // Üzerine eklendiyse: sonsuz kaydırma, sıradaki sayfa.
      if (total === added.length) {
        nextPage = Math.max(1, parseInt(qs().get('page') || '1', 10) || 1);
      }
      run(nextPage, added);
      nextPage++;
    });
    obs.observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initial(); watch(); });
  } else {
    initial();
    watch();
  }
})();
